module.exports = __webpack_public_path__ + "img/level04.b5bbbeb9.png";